import { useAlerts } from "../../system/providers/plugin/index";
import { AlertItem } from "../../system/providers/AlertsContext";

export const useSafeAlerts = () => {
    try {
        // Пытаемся использовать обычный хук
        return useAlerts();
    } catch (e) {
        // Если контекст недоступен, возвращаем заглушку        
        return {
            alerts: [],
            markAsRead: (id: string) => {               
                // Логика для обновления localStorage
                const historyStr = localStorage.getItem("alertsHistory");
                if (historyStr) {
                    try {
                        const history = JSON.parse(historyStr);
                        const updatedHistory = history.map((item: AlertItem) =>
                            item.id === id ? { ...item, read: true } : item
                        );
                        
                        localStorage.setItem("alertsHistory", JSON.stringify(updatedHistory));
                        
                        const event = new CustomEvent('alertsUpdated', {
                            detail: { updatedHistory }
                        });

                        window.dispatchEvent(event);
                        

                    } catch (error) {
                        console.error('Error updating localStorage:', error);
                    }
                }
            },
            // addAlert: (alert: Omit<AlertItem, "id" | "timestamp">) => {
            //     console.log('addAlert fallback called:', alert);
            //     // Логика для добавления в localStorage
            //     const historyStr = localStorage.getItem("alertsHistory");
            //     if (historyStr) {
            //         try {
            //             const history = JSON.parse(historyStr);
            //             const newAlert: AlertItem = {
            //                 ...alert,
            //                 id: `fallback-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
            //                 timestamp: Date.now(),
            //                 read: false
            //             };
            //             const updatedHistory = [newAlert, ...history].slice(0, 50); // Ограничиваем историю
            //             localStorage.setItem("alertsHistory", JSON.stringify(updatedHistory));
            //         } catch (error) {
            //             console.error('Error adding alert to localStorage:', error);
            //         }
            //     }
            // },
            // removeAlert: (id: string) => {
            //     console.log('removeAlert fallback called:', id);
            // },
            // clearAlerts: () => {
            //     console.log('clearAlerts fallback called');
            // },
            // history: [],
            // clearHistory: () => {
            //     console.log('clearHistory fallback called');
            //     localStorage.removeItem("alertsHistory");
            // },
            // removeFromHistory: (id: string) => {
            //     console.log('removeFromHistory fallback called:', id);
            //     const historyStr = localStorage.getItem("alertsHistory");
            //     if (historyStr) {
            //         try {
            //             const history = JSON.parse(historyStr);
            //             const updatedHistory = history.filter((item: AlertItem) => item.id !== id);
            //             localStorage.setItem("alertsHistory", JSON.stringify(updatedHistory));
            //         } catch (error) {
            //             console.error('Error removing from history:', error);
            //         }
            //     }
            // },
            
            // markAsUnread: (id: string) => {
            //     console.log('markAsUnread fallback called:', id);
            //     const historyStr = localStorage.getItem("alertsHistory");
            //     if (historyStr) {
            //         try {
            //             const history = JSON.parse(historyStr);
            //             const updatedHistory = history.map((item: AlertItem) =>
            //                 item.id === id ? { ...item, read: false } : item
            //             );
            //             localStorage.setItem("alertsHistory", JSON.stringify(updatedHistory));
            //         } catch (error) {
            //             console.error('Error marking as unread:', error);
            //         }
            //     }
            // }
        };
    }
};